var map = {
	"./Bidi_Class/Arabic_Letter": "5OU4",
	"./Bidi_Class/Arabic_Letter.json": "5OU4",
	"./Bidi_Class/Arabic_Number": "EAnJ",
	"./Bidi_Class/Arabic_Number.json": "EAnJ",
	"./Bidi_Class/Boundary_Neutral": "5sgG",
	"./Bidi_Class/Boundary_Neutral.json": "5sgG",
	"./Bidi_Class/Common_Separator": "hgX6",
	"./Bidi_Class/Common_Separator.json": "hgX6",
	"./Bidi_Class/European_Number": "0E0Q",
	"./Bidi_Class/European_Number.json": "0E0Q",
	"./Bidi_Class/European_Separator": "I9R7",
	"./Bidi_Class/European_Separator.json": "I9R7",
	"./Bidi_Class/European_Terminator": "1DM7",
	"./Bidi_Class/European_Terminator.json": "1DM7",
	"./Bidi_Class/First_Strong_Isolate": "z6yd",
	"./Bidi_Class/First_Strong_Isolate.json": "z6yd",
	"./Bidi_Class/Left_To_Right": "fV7H",
	"./Bidi_Class/Left_To_Right.json": "fV7H",
	"./Bidi_Class/Left_To_Right_Embedding": "D0xb",
	"./Bidi_Class/Left_To_Right_Embedding.json": "D0xb",
	"./Bidi_Class/Left_To_Right_Isolate": "x+RX",
	"./Bidi_Class/Left_To_Right_Isolate.json": "x+RX",
	"./Bidi_Class/Left_To_Right_Override": "el+g",
	"./Bidi_Class/Left_To_Right_Override.json": "el+g",
	"./Bidi_Class/Nonspacing_Mark": "yoW0",
	"./Bidi_Class/Nonspacing_Mark.json": "yoW0",
	"./Bidi_Class/Other_Neutral": "TZna",
	"./Bidi_Class/Other_Neutral.json": "TZna",
	"./Bidi_Class/Paragraph_Separator": "BB3M",
	"./Bidi_Class/Paragraph_Separator.json": "BB3M",
	"./Bidi_Class/Pop_Directional_Format": "nQNQ",
	"./Bidi_Class/Pop_Directional_Format.json": "nQNQ",
	"./Bidi_Class/Pop_Directional_Isolate": "3mWU",
	"./Bidi_Class/Pop_Directional_Isolate.json": "3mWU",
	"./Bidi_Class/Right_To_Left": "g31c",
	"./Bidi_Class/Right_To_Left.json": "g31c",
	"./Bidi_Class/Right_To_Left_Embedding": "HC9t",
	"./Bidi_Class/Right_To_Left_Embedding.json": "HC9t",
	"./Bidi_Class/Right_To_Left_Isolate": "l2rU",
	"./Bidi_Class/Right_To_Left_Isolate.json": "l2rU",
	"./Bidi_Class/Right_To_Left_Override": "J6yq",
	"./Bidi_Class/Right_To_Left_Override.json": "J6yq",
	"./Bidi_Class/Segment_Separator": "BoaG",
	"./Bidi_Class/Segment_Separator.json": "BoaG",
	"./Bidi_Class/White_Space": "dPBv",
	"./Bidi_Class/White_Space.json": "dPBv",
	"./Bidi_Paired_Bracket_Type/Close": "KDB9",
	"./Bidi_Paired_Bracket_Type/Close.json": "KDB9",
	"./Bidi_Paired_Bracket_Type/None": "S0dr",
	"./Bidi_Paired_Bracket_Type/None.json": "S0dr",
	"./Bidi_Paired_Bracket_Type/Open": "RvbU",
	"./Bidi_Paired_Bracket_Type/Open.json": "RvbU",
	"./Binary_Property/ASCII": "U2le",
	"./Binary_Property/ASCII.json": "U2le",
	"./Binary_Property/ASCII_Hex_Digit": "iJfq",
	"./Binary_Property/ASCII_Hex_Digit.json": "iJfq",
	"./Binary_Property/Alphabetic": "5l/G",
	"./Binary_Property/Alphabetic.json": "5l/G",
	"./Binary_Property/Any": "n7YA",
	"./Binary_Property/Any.json": "n7YA",
	"./Binary_Property/Assigned": "AAoQ",
	"./Binary_Property/Assigned.json": "AAoQ",
	"./Binary_Property/Bidi_Control": "/RBY",
	"./Binary_Property/Bidi_Control.json": "/RBY",
	"./Binary_Property/Bidi_Mirrored": "f8nB",
	"./Binary_Property/Bidi_Mirrored.json": "f8nB",
	"./Binary_Property/Case_Ignorable": "uO3b",
	"./Binary_Property/Case_Ignorable.json": "uO3b",
	"./Binary_Property/Cased": "kDfM",
	"./Binary_Property/Cased.json": "kDfM",
	"./Binary_Property/Changes_When_Casefolded": "Gp11",
	"./Binary_Property/Changes_When_Casefolded.json": "Gp11",
	"./Binary_Property/Changes_When_Casemapped": "ix0F",
	"./Binary_Property/Changes_When_Casemapped.json": "ix0F",
	"./Binary_Property/Changes_When_Lowercased": "OZft",
	"./Binary_Property/Changes_When_Lowercased.json": "OZft",
	"./Binary_Property/Changes_When_NFKC_Casefolded": "xBfw",
	"./Binary_Property/Changes_When_NFKC_Casefolded.json": "xBfw",
	"./Binary_Property/Changes_When_Titlecased": "0d6k",
	"./Binary_Property/Changes_When_Titlecased.json": "0d6k",
	"./Binary_Property/Changes_When_Uppercased": "Uxwm",
	"./Binary_Property/Changes_When_Uppercased.json": "Uxwm",
	"./Binary_Property/Composition_Exclusion": "yH2e",
	"./Binary_Property/Composition_Exclusion.json": "yH2e",
	"./Binary_Property/Dash": "NVX6",
	"./Binary_Property/Dash.json": "NVX6",
	"./Binary_Property/Default_Ignorable_Code_Point": "MNuN",
	"./Binary_Property/Default_Ignorable_Code_Point.json": "MNuN",
	"./Binary_Property/Deprecated": "w/ia",
	"./Binary_Property/Deprecated.json": "w/ia",
	"./Binary_Property/Diacritic": "ZdkN",
	"./Binary_Property/Diacritic.json": "ZdkN",
	"./Binary_Property/Expands_On_NFC": "85nO",
	"./Binary_Property/Expands_On_NFC.json": "85nO",
	"./Binary_Property/Expands_On_NFD": "v5sk",
	"./Binary_Property/Expands_On_NFD.json": "v5sk",
	"./Binary_Property/Expands_On_NFKC": "SqN2",
	"./Binary_Property/Expands_On_NFKC.json": "SqN2",
	"./Binary_Property/Expands_On_NFKD": "kb6W",
	"./Binary_Property/Expands_On_NFKD.json": "kb6W",
	"./Binary_Property/Extender": "W4gq",
	"./Binary_Property/Extender.json": "W4gq",
	"./Binary_Property/Full_Composition_Exclusion": "ocZw",
	"./Binary_Property/Full_Composition_Exclusion.json": "ocZw",
	"./Binary_Property/Grapheme_Base": "Mpf9",
	"./Binary_Property/Grapheme_Base.json": "Mpf9",
	"./Binary_Property/Grapheme_Extend": "Oggr",
	"./Binary_Property/Grapheme_Extend.json": "Oggr",
	"./Binary_Property/Grapheme_Link": "qAaG",
	"./Binary_Property/Grapheme_Link.json": "qAaG",
	"./Binary_Property/Hex_Digit": "+xaG",
	"./Binary_Property/Hex_Digit.json": "+xaG",
	"./Binary_Property/Hyphen": "/h7R",
	"./Binary_Property/Hyphen.json": "/h7R",
	"./Binary_Property/IDS_Binary_Operator": "QzC7",
	"./Binary_Property/IDS_Binary_Operator.json": "QzC7",
	"./Binary_Property/IDS_Trinary_Operator": "zZOl",
	"./Binary_Property/IDS_Trinary_Operator.json": "zZOl",
	"./Binary_Property/ID_Continue": "7mzk",
	"./Binary_Property/ID_Continue.json": "7mzk",
	"./Binary_Property/ID_Start": "U/cR",
	"./Binary_Property/ID_Start.json": "U/cR",
	"./Binary_Property/Ideographic": "GMWB",
	"./Binary_Property/Ideographic.json": "GMWB",
	"./Binary_Property/Join_Control": "hjYy",
	"./Binary_Property/Join_Control.json": "hjYy",
	"./Binary_Property/Logical_Order_Exception": "bpRz",
	"./Binary_Property/Logical_Order_Exception.json": "bpRz",
	"./Binary_Property/Lowercase": "EJC6",
	"./Binary_Property/Lowercase.json": "EJC6",
	"./Binary_Property/Math": "UZiB",
	"./Binary_Property/Math.json": "UZiB",
	"./Binary_Property/Noncharacter_Code_Point": "oFxe",
	"./Binary_Property/Noncharacter_Code_Point.json": "oFxe",
	"./Binary_Property/Other_Alphabetic": "Zikh",
	"./Binary_Property/Other_Alphabetic.json": "Zikh",
	"./Binary_Property/Other_Default_Ignorable_Code_Point": "IZEb",
	"./Binary_Property/Other_Default_Ignorable_Code_Point.json": "IZEb",
	"./Binary_Property/Other_Grapheme_Extend": "xsNJ",
	"./Binary_Property/Other_Grapheme_Extend.json": "xsNJ",
	"./Binary_Property/Other_ID_Continue": "Mdt3",
	"./Binary_Property/Other_ID_Continue.json": "Mdt3",
	"./Binary_Property/Other_ID_Start": "kzbw",
	"./Binary_Property/Other_ID_Start.json": "kzbw",
	"./Binary_Property/Other_Lowercase": "YkOt",
	"./Binary_Property/Other_Lowercase.json": "YkOt",
	"./Binary_Property/Other_Math": "AKYl",
	"./Binary_Property/Other_Math.json": "AKYl",
	"./Binary_Property/Other_Uppercase": "VO6a",
	"./Binary_Property/Other_Uppercase.json": "VO6a",
	"./Binary_Property/Pattern_Syntax": "cXTI",
	"./Binary_Property/Pattern_Syntax.json": "cXTI",
	"./Binary_Property/Pattern_White_Space": "ylhI",
	"./Binary_Property/Pattern_White_Space.json": "ylhI",
	"./Binary_Property/Prepended_Concatenation_Mark": "Cf/3",
	"./Binary_Property/Prepended_Concatenation_Mark.json": "Cf/3",
	"./Binary_Property/Quotation_Mark": "JxcI",
	"./Binary_Property/Quotation_Mark.json": "JxcI",
	"./Binary_Property/Radical": "cjfN",
	"./Binary_Property/Radical.json": "cjfN",
	"./Binary_Property/Regional_Indicator": "szie",
	"./Binary_Property/Regional_Indicator.json": "szie",
	"./Binary_Property/Sentence_Terminal": "e7N2",
	"./Binary_Property/Sentence_Terminal.json": "e7N2",
	"./Binary_Property/Soft_Dotted": "1z7E",
	"./Binary_Property/Soft_Dotted.json": "1z7E",
	"./Binary_Property/Terminal_Punctuation": "kXJv",
	"./Binary_Property/Terminal_Punctuation.json": "kXJv",
	"./Binary_Property/Unified_Ideograph": "5c43",
	"./Binary_Property/Unified_Ideograph.json": "5c43",
	"./Binary_Property/Uppercase": "0dyw",
	"./Binary_Property/Uppercase.json": "0dyw",
	"./Binary_Property/Variation_Selector": "thsG",
	"./Binary_Property/Variation_Selector.json": "thsG",
	"./Binary_Property/White_Space": "sj9d",
	"./Binary_Property/White_Space.json": "sj9d",
	"./Binary_Property/XID_Continue": "KR6Q",
	"./Binary_Property/XID_Continue.json": "KR6Q",
	"./Binary_Property/XID_Start": "fPsH",
	"./Binary_Property/XID_Start.json": "fPsH",
	"./Block/Adlam": "E1oZ",
	"./Block/Adlam.json": "E1oZ",
	"./Block/Aegean_Numbers": "jQyQ",
	"./Block/Aegean_Numbers.json": "jQyQ",
	"./Block/Ahom": "n/zf",
	"./Block/Ahom.json": "n/zf",
	"./Block/Alchemical_Symbols": "0vtI",
	"./Block/Alchemical_Symbols.json": "0vtI",
	"./Block/Alphabetic_Presentation_Forms": "I606",
	"./Block/Alphabetic_Presentation_Forms.json": "I606",
	"./Block/Anatolian_Hieroglyphs": "LJsV",
	"./Block/Anatolian_Hieroglyphs.json": "LJsV",
	"./Block/Ancient_Greek_Musical_Notation": "UAfu",
	"./Block/Ancient_Greek_Musical_Notation.json": "UAfu",
	"./Block/Ancient_Greek_Numbers": "TaHu",
	"./Block/Ancient_Greek_Numbers.json": "TaHu",
	"./Block/Ancient_Symbols": "hgCc",
	"./Block/Ancient_Symbols.json": "hgCc",
	"./Block/Arabic": "R77o",
	"./Block/Arabic.json": "R77o",
	"./Block/Arabic_Extended_A": "68ah",
	"./Block/Arabic_Extended_A.json": "68ah",
	"./Block/Arabic_Mathematical_Alphabetic_Symbols": "wJ5S",
	"./Block/Arabic_Mathematical_Alphabetic_Symbols.json": "wJ5S",
	"./Block/Arabic_Presentation_Forms_A": "8ydJ",
	"./Block/Arabic_Presentation_Forms_A.json": "8ydJ",
	"./Block/Arabic_Presentation_Forms_B": "zIdb",
	"./Block/Arabic_Presentation_Forms_B.json": "zIdb",
	"./Block/Arabic_Supplement": "LoJK",
	"./Block/Arabic_Supplement.json": "LoJK",
	"./Block/Armenian": "ueiS",
	"./Block/Armenian.json": "ueiS",
	"./Block/Arrows": "+Prn",
	"./Block/Arrows.json": "+Prn",
	"./Block/Avestan": "Qgmb",
	"./Block/Avestan.json": "Qgmb",
	"./Block/Balinese": "pBvN",
	"./Block/Balinese.json": "pBvN",
	"./Block/Bamum": "8fSe",
	"./Block/Bamum.json": "8fSe",
	"./Block/Bamum_Supplement": "LInU",
	"./Block/Bamum_Supplement.json": "LInU",
	"./Block/Basic_Latin": "19A6",
	"./Block/Basic_Latin.json": "19A6",
	"./Block/Bassa_Vah": "6pNJ",
	"./Block/Bassa_Vah.json": "6pNJ",
	"./Block/Batak": "ESII",
	"./Block/Batak.json": "ESII",
	"./Block/Bengali": "wRfk",
	"./Block/Bengali.json": "wRfk",
	"./Block/Bhaiksuki": "cLSO",
	"./Block/Bhaiksuki.json": "cLSO",
	"./Block/Block_Elements": "rtie",
	"./Block/Block_Elements.json": "rtie",
	"./Block/Bopomofo": "NrXb",
	"./Block/Bopomofo.json": "NrXb",
	"./Block/Bopomofo_Extended": "Qt0X",
	"./Block/Bopomofo_Extended.json": "Qt0X",
	"./Block/Box_Drawing": "CbLB",
	"./Block/Box_Drawing.json": "CbLB",
	"./Block/Brahmi": "Zwom",
	"./Block/Brahmi.json": "Zwom",
	"./Block/Braille_Patterns": "+SII",
	"./Block/Braille_Patterns.json": "+SII",
	"./Block/Buginese": "hhgL",
	"./Block/Buginese.json": "hhgL",
	"./Block/Buhid": "hRdu",
	"./Block/Buhid.json": "hRdu",
	"./Block/Byzantine_Musical_Symbols": "adAV",
	"./Block/Byzantine_Musical_Symbols.json": "adAV",
	"./Block/CJK_Compatibility": "vEwC",
	"./Block/CJK_Compatibility.json": "vEwC",
	"./Block/CJK_Compatibility_Forms": "P2oR",
	"./Block/CJK_Compatibility_Forms.json": "P2oR",
	"./Block/CJK_Compatibility_Ideographs": "flEu",
	"./Block/CJK_Compatibility_Ideographs.json": "flEu",
	"./Block/CJK_Compatibility_Ideographs_Supplement": "vG3b",
	"./Block/CJK_Compatibility_Ideographs_Supplement.json": "vG3b",
	"./Block/CJK_Radicals_Supplement": "j0qb",
	"./Block/CJK_Radicals_Supplement.json": "j0qb",
	"./Block/CJK_Strokes": "Zihs",
	"./Block/CJK_Strokes.json": "Zihs",
	"./Block/CJK_Symbols_And_Punctuation": "SDy5",
	"./Block/CJK_Symbols_And_Punctuation.json": "SDy5",
	"./Block/CJK_Unified_Ideographs": "trqk",
	"./Block/CJK_Unified_Ideographs.json": "trqk",
	"./Block/CJK_Unified_Ideographs_Extension_A": "w/5u",
	"./Block/CJK_Unified_Ideographs_Extension_A.json": "w/5u",
	"./Block/CJK_Unified_Ideographs_Extension_B": "T9er",
	"./Block/CJK_Unified_Ideographs_Extension_B.json": "T9er",
	"./Block/CJK_Unified_Ideographs_Extension_C": "lW/6",
	"./Block/CJK_Unified_Ideographs_Extension_C.json": "lW/6",
	"./Block/CJK_Unified_Ideographs_Extension_D": "WwMo",
	"./Block/CJK_Unified_Ideographs_Extension_D.json": "WwMo",
	"./Block/CJK_Unified_Ideographs_Extension_E": "HpPj",
	"./Block/CJK_Unified_Ideographs_Extension_E.json": "HpPj",
	"./Block/Carian": "MGQs",
	"./Block/Carian.json": "MGQs",
	"./Block/Caucasian_Albanian": "/XKb",
	"./Block/Caucasian_Albanian.json": "/XKb",
	"./Block/Chakma": "8wkr",
	"./Block/Chakma.json": "8wkr",
	"./Block/Cham": "yPSE",
	"./Block/Cham.json": "yPSE",
	"./Block/Cherokee": "T9TN",
	"./Block/Cherokee.json": "T9TN",
	"./Block/Cherokee_Supplement": "khHQ",
	"./Block/Cherokee_Supplement.json": "khHQ",
	"./Block/Combining_Diacritical_Marks": "ny9o",
	"./Block/Combining_Diacritical_Marks.json": "ny9o",
	"./Block/Combining_Diacritical_Marks_Extended": "MoSy",
	"./Block/Combining_Diacritical_Marks_Extended.json": "MoSy",
	"./Block/Combining_Diacritical_Marks_For_Symbols": "lH6n",
	"./Block/Combining_Diacritical_Marks_For_Symbols.json": "lH6n",
	"./Block/Combining_Diacritical_Marks_Supplement": "0quv",
	"./Block/Combining_Diacritical_Marks_Supplement.json": "0quv",
	"./Block/Combining_Half_Marks": "0MqC",
	"./Block/Combining_Half_Marks.json": "0MqC",
	"./Block/Common_Indic_Number_Forms": "azRq",
	"./Block/Common_Indic_Number_Forms.json": "azRq",
	"./Block/Control_Pictures": "jE2N",
	"./Block/Control_Pictures.json": "jE2N",
	"./Block/Coptic": "3xiu",
	"./Block/Coptic.json": "3xiu",
	"./Block/Coptic_Epact_Numbers": "VMa6",
	"./Block/Coptic_Epact_Numbers.json": "VMa6",
	"./Block/Counting_Rod_Numerals": "9oyl",
	"./Block/Counting_Rod_Numerals.json": "9oyl",
	"./Block/Cuneiform": "4URA",
	"./Block/Cuneiform.json": "4URA",
	"./Block/Cuneiform_Numbers_And_Punctuation": "q8Ov",
	"./Block/Cuneiform_Numbers_And_Punctuation.json": "q8Ov",
	"./Block/Currency_Symbols": "IbZd",
	"./Block/Currency_Symbols.json": "IbZd",
	"./Block/Cypriot_Syllabary": "ex3m",
	"./Block/Cypriot_Syllabary.json": "ex3m",
	"./Block/Cyrillic": "S/Yv",
	"./Block/Cyrillic.json": "S/Yv",
	"./Block/Cyrillic_Extended_A": "FW/t",
	"./Block/Cyrillic_Extended_A.json": "FW/t",
	"./Block/Cyrillic_Extended_B": "1NVx",
	"./Block/Cyrillic_Extended_B.json": "1NVx",
	"./Block/Cyrillic_Extended_C": "vJFs",
	"./Block/Cyrillic_Extended_C.json": "vJFs",
	"./Block/Cyrillic_Supplement": "6PRY",
	"./Block/Cyrillic_Supplement.json": "6PRY",
	"./Block/Deseret": "zqq4",
	"./Block/Deseret.json": "zqq4",
	"./Block/Devanagari": "NeJn",
	"./Block/Devanagari.json": "NeJn",
	"./Block/Devanagari_Extended": "z4dP",
	"./Block/Devanagari_Extended.json": "z4dP",
	"./Block/Dingbats": "BK3f",
	"./Block/Dingbats.json": "BK3f",
	"./Block/Domino_Tiles": "mSoT",
	"./Block/Domino_Tiles.json": "mSoT",
	"./Block/Duployan": "fSRW",
	"./Block/Duployan.json": "fSRW",
	"./Block/Early_Dynastic_Cuneiform": "HZeT",
	"./Block/Early_Dynastic_Cuneiform.json": "HZeT",
	"./Block/Egyptian_Hieroglyphs": "rjfN",
	"./Block/Egyptian_Hieroglyphs.json": "rjfN",
	"./Block/Elbasan": "Wofb",
	"./Block/Elbasan.json": "Wofb",
	"./Block/Emoticons": "hFI8",
	"./Block/Emoticons.json": "hFI8",
	"./Block/Enclosed_Alphanumeric_Supplement": "Wnsq",
	"./Block/Enclosed_Alphanumeric_Supplement.json": "Wnsq",
	"./Block/Enclosed_Alphanumerics": "ufLt",
	"./Block/Enclosed_Alphanumerics.json": "ufLt",
	"./Block/Enclosed_CJK_Letters_And_Months": "puhT",
	"./Block/Enclosed_CJK_Letters_And_Months.json": "puhT",
	"./Block/Enclosed_Ideographic_Supplement": "Bw81",
	"./Block/Enclosed_Ideographic_Supplement.json": "Bw81",
	"./Block/Ethiopic": "t8TS",
	"./Block/Ethiopic.json": "t8TS",
	"./Block/Ethiopic_Extended": "UjBB",
	"./Block/Ethiopic_Extended.json": "UjBB",
	"./Block/Ethiopic_Extended_A": "cH1W",
	"./Block/Ethiopic_Extended_A.json": "cH1W",
	"./Block/Ethiopic_Supplement": "4f90",
	"./Block/Ethiopic_Supplement.json": "4f90",
	"./Block/General_Punctuation": "hOfD",
	"./Block/General_Punctuation.json": "hOfD",
	"./Block/Geometric_Shapes": "gkxM",
	"./Block/Geometric_Shapes.json": "gkxM",
	"./Block/Geometric_Shapes_Extended": "RhBl",
	"./Block/Geometric_Shapes_Extended.json": "RhBl",
	"./Block/Georgian": "HiY2",
	"./Block/Georgian.json": "HiY2",
	"./Block/Georgian_Supplement": "0gP7",
	"./Block/Georgian_Supplement.json": "0gP7",
	"./Block/Glagolitic": "XtLZ",
	"./Block/Glagolitic.json": "XtLZ",
	"./Block/Glagolitic_Supplement": "n3QK",
	"./Block/Glagolitic_Supplement.json": "n3QK",
	"./Block/Gothic": "8vTB",
	"./Block/Gothic.json": "8vTB",
	"./Block/Grantha": "WqBk",
	"./Block/Grantha.json": "WqBk",
	"./Block/Greek_And_Coptic": "Y3fT",
	"./Block/Greek_And_Coptic.json": "Y3fT",
	"./Block/Greek_Extended": "Sqhn",
	"./Block/Greek_Extended.json": "Sqhn",
	"./Block/Gujarati": "v11f",
	"./Block/Gujarati.json": "v11f",
	"./Block/Gurmukhi": "amky",
	"./Block/Gurmukhi.json": "amky",
	"./Block/Halfwidth_And_Fullwidth_Forms": "XbfF",
	"./Block/Halfwidth_And_Fullwidth_Forms.json": "XbfF",
	"./Block/Hangul_Compatibility_Jamo": "ehh6",
	"./Block/Hangul_Compatibility_Jamo.json": "ehh6",
	"./Block/Hangul_Jamo": "Yx6D",
	"./Block/Hangul_Jamo.json": "Yx6D",
	"./Block/Hangul_Jamo_Extended_A": "f+eU",
	"./Block/Hangul_Jamo_Extended_A.json": "f+eU",
	"./Block/Hangul_Jamo_Extended_B": "yo7Y",
	"./Block/Hangul_Jamo_Extended_B.json": "yo7Y",
	"./Block/Hangul_Syllables": "IRv3",
	"./Block/Hangul_Syllables.json": "IRv3",
	"./Block/Hanunoo": "muIa",
	"./Block/Hanunoo.json": "muIa",
	"./Block/Hatran": "K9Xi",
	"./Block/Hatran.json": "K9Xi",
	"./Block/Hebrew": "xvz1",
	"./Block/Hebrew.json": "xvz1",
	"./Block/High_Private_Use_Surrogates": "8OCB",
	"./Block/High_Private_Use_Surrogates.json": "8OCB",
	"./Block/High_Surrogates": "ccIz",
	"./Block/High_Surrogates.json": "ccIz",
	"./Block/Hiragana": "HLEo",
	"./Block/Hiragana.json": "HLEo",
	"./Block/IPA_Extensions": "Snna",
	"./Block/IPA_Extensions.json": "Snna",
	"./Block/Ideographic_Description_Characters": "jDVf",
	"./Block/Ideographic_Description_Characters.json": "jDVf",
	"./Block/Ideographic_Symbols_And_Punctuation": "2vWg",
	"./Block/Ideographic_Symbols_And_Punctuation.json": "2vWg",
	"./Block/Imperial_Aramaic": "DEf3",
	"./Block/Imperial_Aramaic.json": "DEf3",
	"./Block/Inscriptional_Pahlavi": "I7cO",
	"./Block/Inscriptional_Pahlavi.json": "I7cO",
	"./Block/Inscriptional_Parthian": "dWLi",
	"./Block/Inscriptional_Parthian.json": "dWLi",
	"./Block/Javanese": "jqIM",
	"./Block/Javanese.json": "jqIM",
	"./Block/Kaithi": "QzZw",
	"./Block/Kaithi.json": "QzZw",
	"./Block/Kana_Supplement": "ilDr",
	"./Block/Kana_Supplement.json": "ilDr",
	"./Block/Kanbun": "t01F",
	"./Block/Kanbun.json": "t01F",
	"./Block/Kangxi_Radicals": "QdTt",
	"./Block/Kangxi_Radicals.json": "QdTt",
	"./Block/Kannada": "o97F",
	"./Block/Kannada.json": "o97F",
	"./Block/Katakana": "dOec",
	"./Block/Katakana.json": "dOec",
	"./Block/Katakana_Phonetic_Extensions": "j4I2",
	"./Block/Katakana_Phonetic_Extensions.json": "j4I2",
	"./Block/Kayah_Li": "KJLA",
	"./Block/Kayah_Li.json": "KJLA",
	"./Block/Kharoshthi": "MYYE",
	"./Block/Kharoshthi.json": "MYYE",
	"./Block/Khmer": "9mZi",
	"./Block/Khmer.json": "9mZi",
	"./Block/Khmer_Symbols": "KCfY",
	"./Block/Khmer_Symbols.json": "KCfY",
	"./Block/Khojki": "ARbZ",
	"./Block/Khojki.json": "ARbZ",
	"./Block/Khudawadi": "Bm/H",
	"./Block/Khudawadi.json": "Bm/H",
	"./Block/Lao": "EQkp",
	"./Block/Lao.json": "EQkp",
	"./Block/Latin_1_Supplement": "phGD",
	"./Block/Latin_1_Supplement.json": "phGD",
	"./Block/Latin_Extended_A": "emia",
	"./Block/Latin_Extended_A.json": "emia",
	"./Block/Latin_Extended_Additional": "PFJC",
	"./Block/Latin_Extended_Additional.json": "PFJC",
	"./Block/Latin_Extended_B": "tV3q",
	"./Block/Latin_Extended_B.json": "tV3q",
	"./Block/Latin_Extended_C": "z/IX",
	"./Block/Latin_Extended_C.json": "z/IX",
	"./Block/Latin_Extended_D": "mzgG",
	"./Block/Latin_Extended_D.json": "mzgG",
	"./Block/Latin_Extended_E": "Y/TI",
	"./Block/Latin_Extended_E.json": "Y/TI",
	"./Block/Lepcha": "WdAs",
	"./Block/Lepcha.json": "WdAs",
	"./Block/Letterlike_Symbols": "+2dM",
	"./Block/Letterlike_Symbols.json": "+2dM",
	"./Block/Limbu": "lLgf",
	"./Block/Limbu.json": "lLgf",
	"./Block/Linear_A": "oZpZ",
	"./Block/Linear_A.json": "oZpZ",
	"./Block/Linear_B_Ideograms": "Nt4B",
	"./Block/Linear_B_Ideograms.json": "Nt4B",
	"./Block/Linear_B_Syllabary": "QxGw",
	"./Block/Linear_B_Syllabary.json": "QxGw",
	"./Block/Lisu": "YosQ",
	"./Block/Lisu.json": "YosQ",
	"./Block/Low_Surrogates": "Aibo",
	"./Block/Low_Surrogates.json": "Aibo",
	"./Block/Lycian": "V1PC",
	"./Block/Lycian.json": "V1PC",
	"./Block/Lydian": "7myx",
	"./Block/Lydian.json": "7myx",
	"./Block/Mahajani": "bdu3",
	"./Block/Mahajani.json": "bdu3",
	"./Block/Mahjong_Tiles": "NCCz",
	"./Block/Mahjong_Tiles.json": "NCCz",
	"./Block/Malayalam": "1Fdg",
	"./Block/Malayalam.json": "1Fdg",
	"./Block/Mandaic": "5w+9",
	"./Block/Mandaic.json": "5w+9",
	"./Block/Manichaean": "EeM8",
	"./Block/Manichaean.json": "EeM8",
	"./Block/Marchen": "XkGs",
	"./Block/Marchen.json": "XkGs",
	"./Block/Mathematical_Alphanumeric_Symbols": "Cd57",
	"./Block/Mathematical_Alphanumeric_Symbols.json": "Cd57",
	"./Block/Mathematical_Operators": "nDAm",
	"./Block/Mathematical_Operators.json": "nDAm",
	"./Block/Meetei_Mayek": "V4EC",
	"./Block/Meetei_Mayek.json": "V4EC",
	"./Block/Meetei_Mayek_Extensions": "zfXH",
	"./Block/Meetei_Mayek_Extensions.json": "zfXH",
	"./Block/Mende_Kikakui": "aQqP",
	"./Block/Mende_Kikakui.json": "aQqP",
	"./Block/Meroitic_Cursive": "G3fy",
	"./Block/Meroitic_Cursive.json": "G3fy",
	"./Block/Meroitic_Hieroglyphs": "Tmxx",
	"./Block/Meroitic_Hieroglyphs.json": "Tmxx",
	"./Block/Miao": "cwa4",
	"./Block/Miao.json": "cwa4",
	"./Block/Miscellaneous_Mathematical_Symbols_A": "KbK4",
	"./Block/Miscellaneous_Mathematical_Symbols_A.json": "KbK4",
	"./Block/Miscellaneous_Mathematical_Symbols_B": "v7Lu",
	"./Block/Miscellaneous_Mathematical_Symbols_B.json": "v7Lu",
	"./Block/Miscellaneous_Symbols": "+dXe",
	"./Block/Miscellaneous_Symbols.json": "+dXe",
	"./Block/Miscellaneous_Symbols_And_Arrows": "cput",
	"./Block/Miscellaneous_Symbols_And_Arrows.json": "cput",
	"./Block/Miscellaneous_Symbols_And_Pictographs": "WNX4",
	"./Block/Miscellaneous_Symbols_And_Pictographs.json": "WNX4",
	"./Block/Miscellaneous_Technical": "psRY",
	"./Block/Miscellaneous_Technical.json": "psRY",
	"./Block/Modi": "uQuR",
	"./Block/Modi.json": "uQuR",
	"./Block/Modifier_Tone_Letters": "MzMj",
	"./Block/Modifier_Tone_Letters.json": "MzMj",
	"./Block/Mongolian": "1Ivj",
	"./Block/Mongolian.json": "1Ivj",
	"./Block/Mongolian_Supplement": "UUft",
	"./Block/Mongolian_Supplement.json": "UUft",
	"./Block/Mro": "94kG",
	"./Block/Mro.json": "94kG",
	"./Block/Multani": "Fxgf",
	"./Block/Multani.json": "Fxgf",
	"./Block/Musical_Symbols": "1Qi/",
	"./Block/Musical_Symbols.json": "1Qi/",
	"./Block/Myanmar": "gBFw",
	"./Block/Myanmar.json": "gBFw",
	"./Block/Myanmar_Extended_A": "Yhsm",
	"./Block/Myanmar_Extended_A.json": "Yhsm",
	"./Block/Myanmar_Extended_B": "Mt/5",
	"./Block/Myanmar_Extended_B.json": "Mt/5",
	"./Block/NKo": "GZO+",
	"./Block/NKo.json": "GZO+",
	"./Block/Nabataean": "19Pk",
	"./Block/Nabataean.json": "19Pk",
	"./Block/New_Tai_Lue": "ACu1",
	"./Block/New_Tai_Lue.json": "ACu1",
	"./Block/Newa": "uvK6",
	"./Block/Newa.json": "uvK6",
	"./Block/Number_Forms": "IODo",
	"./Block/Number_Forms.json": "IODo",
	"./Block/Ogham": "l1yq",
	"./Block/Ogham.json": "l1yq",
	"./Block/Ol_Chiki": "PSfw",
	"./Block/Ol_Chiki.json": "PSfw",
	"./Block/Old_Hungarian": "fDAu",
	"./Block/Old_Hungarian.json": "fDAu",
	"./Block/Old_Italic": "1cjB",
	"./Block/Old_Italic.json": "1cjB",
	"./Block/Old_North_Arabian": "ge/j",
	"./Block/Old_North_Arabian.json": "ge/j",
	"./Block/Old_Permic": "i6sf",
	"./Block/Old_Permic.json": "i6sf",
	"./Block/Old_Persian": "zaB7",
	"./Block/Old_Persian.json": "zaB7",
	"./Block/Old_South_Arabian": "fHru",
	"./Block/Old_South_Arabian.json": "fHru",
	"./Block/Old_Turkic": "kU0i",
	"./Block/Old_Turkic.json": "kU0i",
	"./Block/Optical_Character_Recognition": "b+cn",
	"./Block/Optical_Character_Recognition.json": "b+cn",
	"./Block/Oriya": "VKVd",
	"./Block/Oriya.json": "VKVd",
	"./Block/Ornamental_Dingbats": "ZDWF",
	"./Block/Ornamental_Dingbats.json": "ZDWF",
	"./Block/Osage": "lp46",
	"./Block/Osage.json": "lp46",
	"./Block/Osmanya": "CLhH",
	"./Block/Osmanya.json": "CLhH",
	"./Block/Pahawh_Hmong": "qSun",
	"./Block/Pahawh_Hmong.json": "qSun",
	"./Block/Palmyrene": "hgRY",
	"./Block/Palmyrene.json": "hgRY",
	"./Block/Pau_Cin_Hau": "hzMK",
	"./Block/Pau_Cin_Hau.json": "hzMK",
	"./Block/Phags_Pa": "tFqU",
	"./Block/Phags_Pa.json": "tFqU",
	"./Block/Phaistos_Disc": "02OV",
	"./Block/Phaistos_Disc.json": "02OV",
	"./Block/Phoenician": "7GaU",
	"./Block/Phoenician.json": "7GaU",
	"./Block/Phonetic_Extensions": "9wIV",
	"./Block/Phonetic_Extensions.json": "9wIV",
	"./Block/Phonetic_Extensions_Supplement": "CnSm",
	"./Block/Phonetic_Extensions_Supplement.json": "CnSm",
	"./Block/Playing_Cards": "USeF",
	"./Block/Playing_Cards.json": "USeF",
	"./Block/Private_Use_Area": "ye1S",
	"./Block/Private_Use_Area.json": "ye1S",
	"./Block/Psalter_Pahlavi": "zeYN",
	"./Block/Psalter_Pahlavi.json": "zeYN",
	"./Block/Rejang": "JSD/",
	"./Block/Rejang.json": "JSD/",
	"./Block/Rumi_Numeral_Symbols": "uCBK",
	"./Block/Rumi_Numeral_Symbols.json": "uCBK",
	"./Block/Runic": "8NwM",
	"./Block/Runic.json": "8NwM",
	"./Block/Samaritan": "ksYO",
	"./Block/Samaritan.json": "ksYO",
	"./Block/Saurashtra": "nLBR",
	"./Block/Saurashtra.json": "nLBR",
	"./Block/Sharada": "Sqc2",
	"./Block/Sharada.json": "Sqc2",
	"./Block/Shavian": "E7zi",
	"./Block/Shavian.json": "E7zi",
	"./Block/Shorthand_Format_Controls": "Rl5m",
	"./Block/Shorthand_Format_Controls.json": "Rl5m",
	"./Block/Siddham": "pUhL",
	"./Block/Siddham.json": "pUhL",
	"./Block/Sinhala": "UmdW",
	"./Block/Sinhala.json": "UmdW",
	"./Block/Sinhala_Archaic_Numbers": "oVIJ",
	"./Block/Sinhala_Archaic_Numbers.json": "oVIJ",
	"./Block/Small_Form_Variants": "4kjj",
	"./Block/Small_Form_Variants.json": "4kjj",
	"./Block/Sora_Sompeng": "hBLm",
	"./Block/Sora_Sompeng.json": "hBLm",
	"./Block/Spacing_Modifier_Letters": "Jsnr",
	"./Block/Spacing_Modifier_Letters.json": "Jsnr",
	"./Block/Specials": "YfIu",
	"./Block/Specials.json": "YfIu",
	"./Block/Sundanese": "Qk58",
	"./Block/Sundanese.json": "Qk58",
	"./Block/Sundanese_Supplement": "JghE",
	"./Block/Sundanese_Supplement.json": "JghE",
	"./Block/Superscripts_And_Subscripts": "Lynk",
	"./Block/Superscripts_And_Subscripts.json": "Lynk",
	"./Block/Supplemental_Arrows_A": "2Nv4",
	"./Block/Supplemental_Arrows_A.json": "2Nv4",
	"./Block/Supplemental_Arrows_B": "6ovv",
	"./Block/Supplemental_Arrows_B.json": "6ovv",
	"./Block/Supplemental_Arrows_C": "QU01",
	"./Block/Supplemental_Arrows_C.json": "QU01",
	"./Block/Supplemental_Mathematical_Operators": "bCZ9",
	"./Block/Supplemental_Mathematical_Operators.json": "bCZ9",
	"./Block/Supplemental_Punctuation": "zqPl",
	"./Block/Supplemental_Punctuation.json": "zqPl",
	"./Block/Supplemental_Symbols_And_Pictographs": "+3tw",
	"./Block/Supplemental_Symbols_And_Pictographs.json": "+3tw",
	"./Block/Supplementary_Private_Use_Area_A": "gv9N",
	"./Block/Supplementary_Private_Use_Area_A.json": "gv9N",
	"./Block/Supplementary_Private_Use_Area_B": "qLcL",
	"./Block/Supplementary_Private_Use_Area_B.json": "qLcL",
	"./Block/Sutton_SignWriting": "0z10",
	"./Block/Sutton_SignWriting.json": "0z10",
	"./Block/Syloti_Nagri": "4tJz",
	"./Block/Syloti_Nagri.json": "4tJz",
	"./Block/Syriac": "7sQK",
	"./Block/Syriac.json": "7sQK",
	"./Block/Tagalog": "BPjD",
	"./Block/Tagalog.json": "BPjD",
	"./Block/Tagbanwa": "Nx07",
	"./Block/Tagbanwa.json": "Nx07",
	"./Block/Tags": "jIw+",
	"./Block/Tags.json": "jIw+",
	"./Block/Tai_Le": "1PGM",
	"./Block/Tai_Le.json": "1PGM",
	"./Block/Tai_Tham": "SsTk",
	"./Block/Tai_Tham.json": "SsTk",
	"./Block/Tai_Viet": "q4E9",
	"./Block/Tai_Viet.json": "q4E9",
	"./Block/Tai_Xuan_Jing_Symbols": "ph3n",
	"./Block/Tai_Xuan_Jing_Symbols.json": "ph3n",
	"./Block/Takri": "EZkI",
	"./Block/Takri.json": "EZkI",
	"./Block/Tamil": "U91o",
	"./Block/Tamil.json": "U91o",
	"./Block/Tangut": "PvKc",
	"./Block/Tangut.json": "PvKc",
	"./Block/Tangut_Components": "ln9z",
	"./Block/Tangut_Components.json": "ln9z",
	"./Block/Telugu": "7Tz0",
	"./Block/Telugu.json": "7Tz0",
	"./Block/Thaana": "WxBi",
	"./Block/Thaana.json": "WxBi",
	"./Block/Thai": "jOvN",
	"./Block/Thai.json": "jOvN",
	"./Block/Tibetan": "OF0H",
	"./Block/Tibetan.json": "OF0H",
	"./Block/Tifinagh": "oXeX",
	"./Block/Tifinagh.json": "oXeX",
	"./Block/Tirhuta": "OUOv",
	"./Block/Tirhuta.json": "OUOv",
	"./Block/Transport_And_Map_Symbols": "Muo9",
	"./Block/Transport_And_Map_Symbols.json": "Muo9",
	"./Block/Ugaritic": "39/O",
	"./Block/Ugaritic.json": "39/O",
	"./Block/Unified_Canadian_Aboriginal_Syllabics": "sRYY",
	"./Block/Unified_Canadian_Aboriginal_Syllabics.json": "sRYY",
	"./Block/Unified_Canadian_Aboriginal_Syllabics_Extended": "j8Pa",
	"./Block/Unified_Canadian_Aboriginal_Syllabics_Extended.json": "j8Pa",
	"./Block/Vai": "epQb",
	"./Block/Vai.json": "epQb",
	"./Block/Variation_Selectors": "1Z8+",
	"./Block/Variation_Selectors.json": "1Z8+",
	"./Block/Variation_Selectors_Supplement": "ZJvY",
	"./Block/Variation_Selectors_Supplement.json": "ZJvY",
	"./Block/Vedic_Extensions": "UOEp",
	"./Block/Vedic_Extensions.json": "UOEp",
	"./Block/Vertical_Forms": "gcdJ",
	"./Block/Vertical_Forms.json": "gcdJ",
	"./Block/Warang_Citi": "Vrfy",
	"./Block/Warang_Citi.json": "Vrfy",
	"./Block/Yi_Radicals": "qrOt",
	"./Block/Yi_Radicals.json": "qrOt",
	"./Block/Yi_Syllables": "5o4b",
	"./Block/Yi_Syllables.json": "5o4b",
	"./Block/Yijing_Hexagram_Symbols": "Xe6r",
	"./Block/Yijing_Hexagram_Symbols.json": "Xe6r",
	"./Block/undefined": "4QIk",
	"./Block/undefined.json": "4QIk",
	"./Case_Folding/C": "3FJU",
	"./Case_Folding/C.json": "3FJU",
	"./Case_Folding/F": "Q1OX",
	"./Case_Folding/F.json": "Q1OX",
	"./Case_Folding/S": "xHsT",
	"./Case_Folding/S.json": "xHsT",
	"./Case_Folding/T": "eob6",
	"./Case_Folding/T.json": "eob6",
	"./General_Category/Cased_Letter": "rN+X",
	"./General_Category/Cased_Letter.json": "rN+X",
	"./General_Category/Close_Punctuation": "Rlsn",
	"./General_Category/Close_Punctuation.json": "Rlsn",
	"./General_Category/Connector_Punctuation": "g/Ju",
	"./General_Category/Connector_Punctuation.json": "g/Ju",
	"./General_Category/Control": "x1ns",
	"./General_Category/Control.json": "x1ns",
	"./General_Category/Currency_Symbol": "86g6",
	"./General_Category/Currency_Symbol.json": "86g6",
	"./General_Category/Dash_Punctuation": "JJ27",
	"./General_Category/Dash_Punctuation.json": "JJ27",
	"./General_Category/Decimal_Number": "O/S4",
	"./General_Category/Decimal_Number.json": "O/S4",
	"./General_Category/Enclosing_Mark": "jz7d",
	"./General_Category/Enclosing_Mark.json": "jz7d",
	"./General_Category/Final_Punctuation": "7ynw",
	"./General_Category/Final_Punctuation.json": "7ynw",
	"./General_Category/Format": "35R5",
	"./General_Category/Format.json": "35R5",
	"./General_Category/Initial_Punctuation": "9k6V",
	"./General_Category/Initial_Punctuation.json": "9k6V",
	"./General_Category/Letter": "xg+u",
	"./General_Category/Letter.json": "xg+u",
	"./General_Category/Letter_Number": "hZK4",
	"./General_Category/Letter_Number.json": "hZK4",
	"./General_Category/Line_Separator": "z0mW",
	"./General_Category/Line_Separator.json": "z0mW",
	"./General_Category/Lowercase_Letter": "Upfa",
	"./General_Category/Lowercase_Letter.json": "Upfa",
	"./General_Category/Mark": "JSl8",
	"./General_Category/Mark.json": "JSl8",
	"./General_Category/Math_Symbol": "Dk8G",
	"./General_Category/Math_Symbol.json": "Dk8G",
	"./General_Category/Modifier_Letter": "R1m2",
	"./General_Category/Modifier_Letter.json": "R1m2",
	"./General_Category/Modifier_Symbol": "BG9q",
	"./General_Category/Modifier_Symbol.json": "BG9q",
	"./General_Category/Nonspacing_Mark": "6s7/",
	"./General_Category/Nonspacing_Mark.json": "6s7/",
	"./General_Category/Number": "8hfX",
	"./General_Category/Number.json": "8hfX",
	"./General_Category/Open_Punctuation": "4REy",
	"./General_Category/Open_Punctuation.json": "4REy",
	"./General_Category/Other": "6Imi",
	"./General_Category/Other.json": "6Imi",
	"./General_Category/Other_Letter": "lcAo",
	"./General_Category/Other_Letter.json": "lcAo",
	"./General_Category/Other_Number": "m3Ls",
	"./General_Category/Other_Number.json": "m3Ls",
	"./General_Category/Other_Punctuation": "1JVO",
	"./General_Category/Other_Punctuation.json": "1JVO",
	"./General_Category/Other_Symbol": "eo4A",
	"./General_Category/Other_Symbol.json": "eo4A",
	"./General_Category/Paragraph_Separator": "yLjP",
	"./General_Category/Paragraph_Separator.json": "yLjP",
	"./General_Category/Private_Use": "bU0G",
	"./General_Category/Private_Use.json": "bU0G",
	"./General_Category/Punctuation": "TMPF",
	"./General_Category/Punctuation.json": "TMPF",
	"./General_Category/Separator": "ZQkb",
	"./General_Category/Separator.json": "ZQkb",
	"./General_Category/Space_Separator": "iJEr",
	"./General_Category/Space_Separator.json": "iJEr",
	"./General_Category/Spacing_Mark": "WuHm",
	"./General_Category/Spacing_Mark.json": "WuHm",
	"./General_Category/Surrogate": "NYBw",
	"./General_Category/Surrogate.json": "NYBw",
	"./General_Category/Symbol": "IjPr",
	"./General_Category/Symbol.json": "IjPr",
	"./General_Category/Titlecase_Letter": "K7T9",
	"./General_Category/Titlecase_Letter.json": "K7T9",
	"./General_Category/Unassigned": "hWnQ",
	"./General_Category/Unassigned.json": "hWnQ",
	"./General_Category/Uppercase_Letter": "YJ9o",
	"./General_Category/Uppercase_Letter.json": "YJ9o",
	"./Line_Break/Alphabetic": "bPwX",
	"./Line_Break/Alphabetic.json": "bPwX",
	"./Line_Break/Ambiguous": "55r/",
	"./Line_Break/Ambiguous.json": "55r/",
	"./Line_Break/Break_After": "aDMv",
	"./Line_Break/Break_After.json": "aDMv",
	"./Line_Break/Break_Before": "Kx1i",
	"./Line_Break/Break_Before.json": "Kx1i",
	"./Line_Break/Break_Both": "QXUq",
	"./Line_Break/Break_Both.json": "QXUq",
	"./Line_Break/Break_Symbols": "SiAT",
	"./Line_Break/Break_Symbols.json": "SiAT",
	"./Line_Break/Carriage_Return": "rG3P",
	"./Line_Break/Carriage_Return.json": "rG3P",
	"./Line_Break/Close_Parenthesis": "0RQX",
	"./Line_Break/Close_Parenthesis.json": "0RQX",
	"./Line_Break/Close_Punctuation": "sBBo",
	"./Line_Break/Close_Punctuation.json": "sBBo",
	"./Line_Break/Combining_Mark": "wHID",
	"./Line_Break/Combining_Mark.json": "wHID",
	"./Line_Break/Complex_Context": "eOXP",
	"./Line_Break/Complex_Context.json": "eOXP",
	"./Line_Break/Conditional_Japanese_Starter": "NN05",
	"./Line_Break/Conditional_Japanese_Starter.json": "NN05",
	"./Line_Break/Contingent_Break": "iVv1",
	"./Line_Break/Contingent_Break.json": "iVv1",
	"./Line_Break/E_Base": "Q+w8",
	"./Line_Break/E_Base.json": "Q+w8",
	"./Line_Break/E_Modifier": "Ox7u",
	"./Line_Break/E_Modifier.json": "Ox7u",
	"./Line_Break/Exclamation": "J6MW",
	"./Line_Break/Exclamation.json": "J6MW",
	"./Line_Break/Glue": "qEDp",
	"./Line_Break/Glue.json": "qEDp",
	"./Line_Break/H2": "Z6J7",
	"./Line_Break/H2.json": "Z6J7",
	"./Line_Break/H3": "uebX",
	"./Line_Break/H3.json": "uebX",
	"./Line_Break/Hebrew_Letter": "CIIv",
	"./Line_Break/Hebrew_Letter.json": "CIIv",
	"./Line_Break/Hyphen": "tfwT",
	"./Line_Break/Hyphen.json": "tfwT",
	"./Line_Break/Ideographic": "oLK3",
	"./Line_Break/Ideographic.json": "oLK3",
	"./Line_Break/Infix_Numeric": "TtBb",
	"./Line_Break/Infix_Numeric.json": "TtBb",
	"./Line_Break/Inseparable": "vKU7",
	"./Line_Break/Inseparable.json": "vKU7",
	"./Line_Break/JL": "j9pN",
	"./Line_Break/JL.json": "j9pN",
	"./Line_Break/JT": "JR3t",
	"./Line_Break/JT.json": "JR3t",
	"./Line_Break/JV": "4r3D",
	"./Line_Break/JV.json": "4r3D",
	"./Line_Break/Line_Feed": "EXCj",
	"./Line_Break/Line_Feed.json": "EXCj",
	"./Line_Break/Mandatory_Break": "vMxj",
	"./Line_Break/Mandatory_Break.json": "vMxj",
	"./Line_Break/Next_Line": "VlNY",
	"./Line_Break/Next_Line.json": "VlNY",
	"./Line_Break/Nonstarter": "Tl4H",
	"./Line_Break/Nonstarter.json": "Tl4H",
	"./Line_Break/Numeric": "srdR",
	"./Line_Break/Numeric.json": "srdR",
	"./Line_Break/Open_Punctuation": "GIUV",
	"./Line_Break/Open_Punctuation.json": "GIUV",
	"./Line_Break/Postfix_Numeric": "Nn8c",
	"./Line_Break/Postfix_Numeric.json": "Nn8c",
	"./Line_Break/Prefix_Numeric": "+hPP",
	"./Line_Break/Prefix_Numeric.json": "+hPP",
	"./Line_Break/Quotation": "hd9X",
	"./Line_Break/Quotation.json": "hd9X",
	"./Line_Break/Regional_Indicator": "7Bs5",
	"./Line_Break/Regional_Indicator.json": "7Bs5",
	"./Line_Break/Space": "o12w",
	"./Line_Break/Space.json": "o12w",
	"./Line_Break/Surrogate": "P36i",
	"./Line_Break/Surrogate.json": "P36i",
	"./Line_Break/Unknown": "Q4g0",
	"./Line_Break/Unknown.json": "Q4g0",
	"./Line_Break/Word_Joiner": "qSgm",
	"./Line_Break/Word_Joiner.json": "qSgm",
	"./Line_Break/ZWJ": "Gf2v",
	"./Line_Break/ZWJ.json": "Gf2v",
	"./Line_Break/ZWSpace": "XuMQ",
	"./Line_Break/ZWSpace.json": "XuMQ",
	"./Script/Adlam": "EYPb",
	"./Script/Adlam.json": "EYPb",
	"./Script/Ahom": "8fp7",
	"./Script/Ahom.json": "8fp7",
	"./Script/Anatolian_Hieroglyphs": "ujUE",
	"./Script/Anatolian_Hieroglyphs.json": "ujUE",
	"./Script/Arabic": "Spa6",
	"./Script/Arabic.json": "Spa6",
	"./Script/Armenian": "fDS7",
	"./Script/Armenian.json": "fDS7",
	"./Script/Avestan": "I0C8",
	"./Script/Avestan.json": "I0C8",
	"./Script/Balinese": "+szg",
	"./Script/Balinese.json": "+szg",
	"./Script/Bamum": "nC7s",
	"./Script/Bamum.json": "nC7s",
	"./Script/Bassa_Vah": "gLlz",
	"./Script/Bassa_Vah.json": "gLlz",
	"./Script/Batak": "HQDr",
	"./Script/Batak.json": "HQDr",
	"./Script/Bengali": "NHBz",
	"./Script/Bengali.json": "NHBz",
	"./Script/Bhaiksuki": "LGY6",
	"./Script/Bhaiksuki.json": "LGY6",
	"./Script/Bopomofo": "5QKq",
	"./Script/Bopomofo.json": "5QKq",
	"./Script/Brahmi": "QM9d",
	"./Script/Brahmi.json": "QM9d",
	"./Script/Braille": "acv+",
	"./Script/Braille.json": "acv+",
	"./Script/Buginese": "QBzP",
	"./Script/Buginese.json": "QBzP",
	"./Script/Buhid": "k0/q",
	"./Script/Buhid.json": "k0/q",
	"./Script/Canadian_Aboriginal": "O+B1",
	"./Script/Canadian_Aboriginal.json": "O+B1",
	"./Script/Carian": "Z6Ob",
	"./Script/Carian.json": "Z6Ob",
	"./Script/Caucasian_Albanian": "06xE",
	"./Script/Caucasian_Albanian.json": "06xE",
	"./Script/Chakma": "sdRu",
	"./Script/Chakma.json": "sdRu",
	"./Script/Cham": "UGz3",
	"./Script/Cham.json": "UGz3",
	"./Script/Cherokee": "UCS0",
	"./Script/Cherokee.json": "UCS0",
	"./Script/Common": "mxYB",
	"./Script/Common.json": "mxYB",
	"./Script/Coptic": "o/Wj",
	"./Script/Coptic.json": "o/Wj",
	"./Script/Cuneiform": "Bl+t",
	"./Script/Cuneiform.json": "Bl+t",
	"./Script/Cypriot": "MF7K",
	"./Script/Cypriot.json": "MF7K",
	"./Script/Cyrillic": "BpFc",
	"./Script/Cyrillic.json": "BpFc",
	"./Script/Deseret": "svf/",
	"./Script/Deseret.json": "svf/",
	"./Script/Devanagari": "650g",
	"./Script/Devanagari.json": "650g",
	"./Script/Duployan": "Ytj2",
	"./Script/Duployan.json": "Ytj2",
	"./Script/Egyptian_Hieroglyphs": "q/2O",
	"./Script/Egyptian_Hieroglyphs.json": "q/2O",
	"./Script/Elbasan": "AryK",
	"./Script/Elbasan.json": "AryK",
	"./Script/Ethiopic": "UxE1",
	"./Script/Ethiopic.json": "UxE1",
	"./Script/Georgian": "ABN+",
	"./Script/Georgian.json": "ABN+",
	"./Script/Glagolitic": "quHD",
	"./Script/Glagolitic.json": "quHD",
	"./Script/Gothic": "0WJf",
	"./Script/Gothic.json": "0WJf",
	"./Script/Grantha": "hs4i",
	"./Script/Grantha.json": "hs4i",
	"./Script/Greek": "F6cP",
	"./Script/Greek.json": "F6cP",
	"./Script/Gujarati": "QW7m",
	"./Script/Gujarati.json": "QW7m",
	"./Script/Gurmukhi": "80mg",
	"./Script/Gurmukhi.json": "80mg",
	"./Script/Han": "tDnG",
	"./Script/Han.json": "tDnG",
	"./Script/Hangul": "eL1F",
	"./Script/Hangul.json": "eL1F",
	"./Script/Hanunoo": "5hx6",
	"./Script/Hanunoo.json": "5hx6",
	"./Script/Hatran": "JxL+",
	"./Script/Hatran.json": "JxL+",
	"./Script/Hebrew": "ruiU",
	"./Script/Hebrew.json": "ruiU",
	"./Script/Hiragana": "+Oo0",
	"./Script/Hiragana.json": "+Oo0",
	"./Script/Imperial_Aramaic": "NQYR",
	"./Script/Imperial_Aramaic.json": "NQYR",
	"./Script/Inherited": "A+T3",
	"./Script/Inherited.json": "A+T3",
	"./Script/Inscriptional_Pahlavi": "+Vzm",
	"./Script/Inscriptional_Pahlavi.json": "+Vzm",
	"./Script/Inscriptional_Parthian": "HS3Z",
	"./Script/Inscriptional_Parthian.json": "HS3Z",
	"./Script/Javanese": "oML9",
	"./Script/Javanese.json": "oML9",
	"./Script/Kaithi": "HP5v",
	"./Script/Kaithi.json": "HP5v",
	"./Script/Kannada": "X+5u",
	"./Script/Kannada.json": "X+5u",
	"./Script/Katakana": "pq3U",
	"./Script/Katakana.json": "pq3U",
	"./Script/Kayah_Li": "jGb8",
	"./Script/Kayah_Li.json": "jGb8",
	"./Script/Kharoshthi": "y7H8",
	"./Script/Kharoshthi.json": "y7H8",
	"./Script/Khmer": "FP6m",
	"./Script/Khmer.json": "FP6m",
	"./Script/Khojki": "Q4Wu",
	"./Script/Khojki.json": "Q4Wu",
	"./Script/Khudawadi": "nLHK",
	"./Script/Khudawadi.json": "nLHK",
	"./Script/Lao": "6m7j",
	"./Script/Lao.json": "6m7j",
	"./Script/Latin": "Ctls",
	"./Script/Latin.json": "Ctls",
	"./Script/Lepcha": "4jRm",
	"./Script/Lepcha.json": "4jRm",
	"./Script/Limbu": "ZXCD",
	"./Script/Limbu.json": "ZXCD",
	"./Script/Linear_A": "/KPG",
	"./Script/Linear_A.json": "/KPG",
	"./Script/Linear_B": "RXdu",
	"./Script/Linear_B.json": "RXdu",
	"./Script/Lisu": "5Wif",
	"./Script/Lisu.json": "5Wif",
	"./Script/Lycian": "CZtl",
	"./Script/Lycian.json": "CZtl",
	"./Script/Lydian": "Jm7q",
	"./Script/Lydian.json": "Jm7q",
	"./Script/Mahajani": "L0a/",
	"./Script/Mahajani.json": "L0a/",
	"./Script/Malayalam": "GqL4",
	"./Script/Malayalam.json": "GqL4",
	"./Script/Mandaic": "lQbH",
	"./Script/Mandaic.json": "lQbH",
	"./Script/Manichaean": "kJbm",
	"./Script/Manichaean.json": "kJbm",
	"./Script/Marchen": "mGcv",
	"./Script/Marchen.json": "mGcv",
	"./Script/Masaram_Gondi": "AjhX",
	"./Script/Masaram_Gondi.json": "AjhX",
	"./Script/Meetei_Mayek": "aJQA",
	"./Script/Meetei_Mayek.json": "aJQA",
	"./Script/Mende_Kikakui": "bze/",
	"./Script/Mende_Kikakui.json": "bze/",
	"./Script/Meroitic_Cursive": "W0g4",
	"./Script/Meroitic_Cursive.json": "W0g4",
	"./Script/Meroitic_Hieroglyphs": "c9Bi",
	"./Script/Meroitic_Hieroglyphs.json": "c9Bi",
	"./Script/Miao": "wF2S",
	"./Script/Miao.json": "wF2S",
	"./Script/Modi": "jg7W",
	"./Script/Modi.json": "jg7W",
	"./Script/Mongolian": "aW3+",
	"./Script/Mongolian.json": "aW3+",
	"./Script/Mro": "6Zbg",
	"./Script/Mro.json": "6Zbg",
	"./Script/Multani": "JBg1",
	"./Script/Multani.json": "JBg1",
	"./Script/Myanmar": "QyWi",
	"./Script/Myanmar.json": "QyWi",
	"./Script/Nabataean": "pYuv",
	"./Script/Nabataean.json": "pYuv",
	"./Script/New_Tai_Lue": "+mIT",
	"./Script/New_Tai_Lue.json": "+mIT",
	"./Script/Newa": "bGfE",
	"./Script/Newa.json": "bGfE",
	"./Script/Nko": "D6Wf",
	"./Script/Nko.json": "D6Wf",
	"./Script/Nushu": "ASqF",
	"./Script/Nushu.json": "ASqF",
	"./Script/Ogham": "8vzi",
	"./Script/Ogham.json": "8vzi",
	"./Script/Ol_Chiki": "DgJj",
	"./Script/Ol_Chiki.json": "DgJj",
	"./Script/Old_Hungarian": "CqVS",
	"./Script/Old_Hungarian.json": "CqVS",
	"./Script/Old_Italic": "Vu5/",
	"./Script/Old_Italic.json": "Vu5/",
	"./Script/Old_North_Arabian": "lMCh",
	"./Script/Old_North_Arabian.json": "lMCh",
	"./Script/Old_Permic": "pSjd",
	"./Script/Old_Permic.json": "pSjd",
	"./Script/Old_Persian": "g0+K",
	"./Script/Old_Persian.json": "g0+K",
	"./Script/Old_South_Arabian": "+mWG",
	"./Script/Old_South_Arabian.json": "+mWG",
	"./Script/Old_Turkic": "YHtU",
	"./Script/Old_Turkic.json": "YHtU",
	"./Script/Oriya": "Jzuq",
	"./Script/Oriya.json": "Jzuq",
	"./Script/Osage": "w+2r",
	"./Script/Osage.json": "w+2r",
	"./Script/Osmanya": "fAoB",
	"./Script/Osmanya.json": "fAoB",
	"./Script/Pahawh_Hmong": "eGjS",
	"./Script/Pahawh_Hmong.json": "eGjS",
	"./Script/Palmyrene": "jzDX",
	"./Script/Palmyrene.json": "jzDX",
	"./Script/Pau_Cin_Hau": "cf2C",
	"./Script/Pau_Cin_Hau.json": "cf2C",
	"./Script/Phags_Pa": "tonr",
	"./Script/Phags_Pa.json": "tonr",
	"./Script/Phoenician": "xv+m",
	"./Script/Phoenician.json": "xv+m",
	"./Script/Psalter_Pahlavi": "gwCM",
	"./Script/Psalter_Pahlavi.json": "gwCM",
	"./Script/Rejang": "zbxG",
	"./Script/Rejang.json": "zbxG",
	"./Script/Runic": "yOIU",
	"./Script/Runic.json": "yOIU",
	"./Script/Samaritan": "/uJm",
	"./Script/Samaritan.json": "/uJm",
	"./Script/Saurashtra": "9ui1",
	"./Script/Saurashtra.json": "9ui1",
	"./Script/Sharada": "dcpC",
	"./Script/Sharada.json": "dcpC",
	"./Script/Shavian": "O3LT",
	"./Script/Shavian.json": "O3LT",
	"./Script/Siddham": "gK4J",
	"./Script/Siddham.json": "gK4J",
	"./Script/SignWriting": "9Rgo",
	"./Script/SignWriting.json": "9Rgo",
	"./Script/Sinhala": "DV4e",
	"./Script/Sinhala.json": "DV4e",
	"./Script/Sora_Sompeng": "P7Ax",
	"./Script/Sora_Sompeng.json": "P7Ax",
	"./Script/Soyombo": "t0vr",
	"./Script/Soyombo.json": "t0vr",
	"./Script/Sundanese": "bZZr",
	"./Script/Sundanese.json": "bZZr",
	"./Script/Syloti_Nagri": "3ws/",
	"./Script/Syloti_Nagri.json": "3ws/",
	"./Script/Syriac": "SVWh",
	"./Script/Syriac.json": "SVWh",
	"./Script/Tagalog": "AfJU",
	"./Script/Tagalog.json": "AfJU",
	"./Script/Tagbanwa": "E8Ir",
	"./Script/Tagbanwa.json": "E8Ir",
	"./Script/Tai_Le": "djYy",
	"./Script/Tai_Le.json": "djYy",
	"./Script/Tai_Tham": "TL8H",
	"./Script/Tai_Tham.json": "TL8H",
	"./Script/Tai_Viet": "NLPz",
	"./Script/Tai_Viet.json": "NLPz",
	"./Script/Takri": "+FOd",
	"./Script/Takri.json": "+FOd",
	"./Script/Tamil": "wR9D",
	"./Script/Tamil.json": "wR9D",
	"./Script/Tangut": "MY9z",
	"./Script/Tangut.json": "MY9z",
	"./Script/Telugu": "jC/o",
	"./Script/Telugu.json": "jC/o",
	"./Script/Thaana": "etCO",
	"./Script/Thaana.json": "etCO",
	"./Script/Thai": "m2nK",
	"./Script/Thai.json": "m2nK",
	"./Script/Tibetan": "PBEt",
	"./Script/Tibetan.json": "PBEt",
	"./Script/Tifinagh": "PrC9",
	"./Script/Tifinagh.json": "PrC9",
	"./Script/Tirhuta": "AsXM",
	"./Script/Tirhuta.json": "AsXM",
	"./Script/Ugaritic": "xJH0",
	"./Script/Ugaritic.json": "xJH0",
	"./Script/Vai": "bW5l",
	"./Script/Vai.json": "bW5l",
	"./Script/Warang_Citi": "NQWP",
	"./Script/Warang_Citi.json": "NQWP",
	"./Script/Yi": "wRaB",
	"./Script/Yi.json": "wRaB",
	"./Script/Zanabazar_Square": "GV1M",
	"./Script/Zanabazar_Square.json": "GV1M",
	"./Script_Extensions/Adlam": "/mMy",
	"./Script_Extensions/Adlam.json": "/mMy",
	"./Script_Extensions/Ahom": "prPR",
	"./Script_Extensions/Ahom.json": "prPR",
	"./Script_Extensions/Anatolian_Hieroglyphs": "EhCc",
	"./Script_Extensions/Anatolian_Hieroglyphs.json": "EhCc",
	"./Script_Extensions/Arabic": "1xnI",
	"./Script_Extensions/Arabic.json": "1xnI",
	"./Script_Extensions/Armenian": "4NOI",
	"./Script_Extensions/Armenian.json": "4NOI",
	"./Script_Extensions/Avestan": "6nuy",
	"./Script_Extensions/Avestan.json": "6nuy",
	"./Script_Extensions/Balinese": "rn0K",
	"./Script_Extensions/Balinese.json": "rn0K",
	"./Script_Extensions/Bamum": "1xEa",
	"./Script_Extensions/Bamum.json": "1xEa",
	"./Script_Extensions/Bassa_Vah": "Doww",
	"./Script_Extensions/Bassa_Vah.json": "Doww",
	"./Script_Extensions/Batak": "cRCg",
	"./Script_Extensions/Batak.json": "cRCg",
	"./Script_Extensions/Bengali": "HRbO",
	"./Script_Extensions/Bengali.json": "HRbO",
	"./Script_Extensions/Bhaiksuki": "fDLJ",
	"./Script_Extensions/Bhaiksuki.json": "fDLJ",
	"./Script_Extensions/Bopomofo": "t49W",
	"./Script_Extensions/Bopomofo.json": "t49W",
	"./Script_Extensions/Brahmi": "EYJY",
	"./Script_Extensions/Brahmi.json": "EYJY",
	"./Script_Extensions/Braille": "8nw/",
	"./Script_Extensions/Braille.json": "8nw/",
	"./Script_Extensions/Buginese": "4O+P",
	"./Script_Extensions/Buginese.json": "4O+P",
	"./Script_Extensions/Buhid": "RFZc",
	"./Script_Extensions/Buhid.json": "RFZc",
	"./Script_Extensions/Canadian_Aboriginal": "4jYt",
	"./Script_Extensions/Canadian_Aboriginal.json": "4jYt",
	"./Script_Extensions/Carian": "Wd7N",
	"./Script_Extensions/Carian.json": "Wd7N",
	"./Script_Extensions/Caucasian_Albanian": "nj1+",
	"./Script_Extensions/Caucasian_Albanian.json": "nj1+",
	"./Script_Extensions/Chakma": "FT1x",
	"./Script_Extensions/Chakma.json": "FT1x",
	"./Script_Extensions/Cham": "zrK6",
	"./Script_Extensions/Cham.json": "zrK6",
	"./Script_Extensions/Cherokee": "tNV1",
	"./Script_Extensions/Cherokee.json": "tNV1",
	"./Script_Extensions/Common": "cErc",
	"./Script_Extensions/Common.json": "cErc",
	"./Script_Extensions/Coptic": "Hbsc",
	"./Script_Extensions/Coptic.json": "Hbsc",
	"./Script_Extensions/Cuneiform": "hkBc",
	"./Script_Extensions/Cuneiform.json": "hkBc",
	"./Script_Extensions/Cypriot": "+TeZ",
	"./Script_Extensions/Cypriot.json": "+TeZ",
	"./Script_Extensions/Cyrillic": "tStO",
	"./Script_Extensions/Cyrillic.json": "tStO",
	"./Script_Extensions/Deseret": "d8Rf",
	"./Script_Extensions/Deseret.json": "d8Rf",
	"./Script_Extensions/Devanagari": "5T0F",
	"./Script_Extensions/Devanagari.json": "5T0F",
	"./Script_Extensions/Duployan": "BHA4",
	"./Script_Extensions/Duployan.json": "BHA4",
	"./Script_Extensions/Egyptian_Hieroglyphs": "+FxW",
	"./Script_Extensions/Egyptian_Hieroglyphs.json": "+FxW",
	"./Script_Extensions/Elbasan": "ofmQ",
	"./Script_Extensions/Elbasan.json": "ofmQ",
	"./Script_Extensions/Ethiopic": "LH3E",
	"./Script_Extensions/Ethiopic.json": "LH3E",
	"./Script_Extensions/Georgian": "7+BV",
	"./Script_Extensions/Georgian.json": "7+BV",
	"./Script_Extensions/Glagolitic": "tFK5",
	"./Script_Extensions/Glagolitic.json": "tFK5",
	"./Script_Extensions/Gothic": "3Luc",
	"./Script_Extensions/Gothic.json": "3Luc",
	"./Script_Extensions/Grantha": "0YIP",
	"./Script_Extensions/Grantha.json": "0YIP",
	"./Script_Extensions/Greek": "Ouhu",
	"./Script_Extensions/Greek.json": "Ouhu",
	"./Script_Extensions/Gujarati": "TkEF",
	"./Script_Extensions/Gujarati.json": "TkEF",
	"./Script_Extensions/Gurmukhi": "yPql",
	"./Script_Extensions/Gurmukhi.json": "yPql",
	"./Script_Extensions/Han": "zQYz",
	"./Script_Extensions/Han.json": "zQYz",
	"./Script_Extensions/Hangul": "ivsH",
	"./Script_Extensions/Hangul.json": "ivsH",
	"./Script_Extensions/Hanunoo": "0Eva",
	"./Script_Extensions/Hanunoo.json": "0Eva",
	"./Script_Extensions/Hatran": "ed+E",
	"./Script_Extensions/Hatran.json": "ed+E",
	"./Script_Extensions/Hebrew": "FGRs",
	"./Script_Extensions/Hebrew.json": "FGRs",
	"./Script_Extensions/Hiragana": "RbbF",
	"./Script_Extensions/Hiragana.json": "RbbF",
	"./Script_Extensions/Imperial_Aramaic": "77nf",
	"./Script_Extensions/Imperial_Aramaic.json": "77nf",
	"./Script_Extensions/Inherited": "GA6x",
	"./Script_Extensions/Inherited.json": "GA6x",
	"./Script_Extensions/Inscriptional_Pahlavi": "TjbX",
	"./Script_Extensions/Inscriptional_Pahlavi.json": "TjbX",
	"./Script_Extensions/Inscriptional_Parthian": "G0cn",
	"./Script_Extensions/Inscriptional_Parthian.json": "G0cn",
	"./Script_Extensions/Javanese": "0pK1",
	"./Script_Extensions/Javanese.json": "0pK1",
	"./Script_Extensions/Kaithi": "41y3",
	"./Script_Extensions/Kaithi.json": "41y3",
	"./Script_Extensions/Kannada": "mskp",
	"./Script_Extensions/Kannada.json": "mskp",
	"./Script_Extensions/Katakana": "n2e6",
	"./Script_Extensions/Katakana.json": "n2e6",
	"./Script_Extensions/Kayah_Li": "kFCp",
	"./Script_Extensions/Kayah_Li.json": "kFCp",
	"./Script_Extensions/Kharoshthi": "BI7m",
	"./Script_Extensions/Kharoshthi.json": "BI7m",
	"./Script_Extensions/Khmer": "Dzyv",
	"./Script_Extensions/Khmer.json": "Dzyv",
	"./Script_Extensions/Khojki": "oT2a",
	"./Script_Extensions/Khojki.json": "oT2a",
	"./Script_Extensions/Khudawadi": "64e7",
	"./Script_Extensions/Khudawadi.json": "64e7",
	"./Script_Extensions/Lao": "RHML",
	"./Script_Extensions/Lao.json": "RHML",
	"./Script_Extensions/Latin": "Bso0",
	"./Script_Extensions/Latin.json": "Bso0",
	"./Script_Extensions/Lepcha": "CU0z",
	"./Script_Extensions/Lepcha.json": "CU0z",
	"./Script_Extensions/Limbu": "u5s/",
	"./Script_Extensions/Limbu.json": "u5s/",
	"./Script_Extensions/Linear_A": "uS8P",
	"./Script_Extensions/Linear_A.json": "uS8P",
	"./Script_Extensions/Linear_B": "W8Ep",
	"./Script_Extensions/Linear_B.json": "W8Ep",
	"./Script_Extensions/Lisu": "lx6/",
	"./Script_Extensions/Lisu.json": "lx6/",
	"./Script_Extensions/Lycian": "POkl",
	"./Script_Extensions/Lycian.json": "POkl",
	"./Script_Extensions/Lydian": "4jCr",
	"./Script_Extensions/Lydian.json": "4jCr",
	"./Script_Extensions/Mahajani": "POzX",
	"./Script_Extensions/Mahajani.json": "POzX",
	"./Script_Extensions/Malayalam": "Hw5m",
	"./Script_Extensions/Malayalam.json": "Hw5m",
	"./Script_Extensions/Mandaic": "0rfu",
	"./Script_Extensions/Mandaic.json": "0rfu",
	"./Script_Extensions/Manichaean": "c3IK",
	"./Script_Extensions/Manichaean.json": "c3IK",
	"./Script_Extensions/Marchen": "4DDO",
	"./Script_Extensions/Marchen.json": "4DDO",
	"./Script_Extensions/Masaram_Gondi": "CYrJ",
	"./Script_Extensions/Masaram_Gondi.json": "CYrJ",
	"./Script_Extensions/Meetei_Mayek": "Wx7Y",
	"./Script_Extensions/Meetei_Mayek.json": "Wx7Y",
	"./Script_Extensions/Mende_Kikakui": "bpXN",
	"./Script_Extensions/Mende_Kikakui.json": "bpXN",
	"./Script_Extensions/Meroitic_Cursive": "P+AA",
	"./Script_Extensions/Meroitic_Cursive.json": "P+AA",
	"./Script_Extensions/Meroitic_Hieroglyphs": "IUb2",
	"./Script_Extensions/Meroitic_Hieroglyphs.json": "IUb2",
	"./Script_Extensions/Miao": "cCY3",
	"./Script_Extensions/Miao.json": "cCY3",
	"./Script_Extensions/Modi": "k/Pa",
	"./Script_Extensions/Modi.json": "k/Pa",
	"./Script_Extensions/Mongolian": "0enn",
	"./Script_Extensions/Mongolian.json": "0enn",
	"./Script_Extensions/Mro": "06og",
	"./Script_Extensions/Mro.json": "06og",
	"./Script_Extensions/Multani": "3N/Y",
	"./Script_Extensions/Multani.json": "3N/Y",
	"./Script_Extensions/Myanmar": "jlYZ",
	"./Script_Extensions/Myanmar.json": "jlYZ",
	"./Script_Extensions/Nabataean": "CtlZ",
	"./Script_Extensions/Nabataean.json": "CtlZ",
	"./Script_Extensions/New_Tai_Lue": "kdvR",
	"./Script_Extensions/New_Tai_Lue.json": "kdvR",
	"./Script_Extensions/Newa": "hvXl",
	"./Script_Extensions/Newa.json": "hvXl",
	"./Script_Extensions/Nko": "7Yk0",
	"./Script_Extensions/Nko.json": "7Yk0",
	"./Script_Extensions/Nushu": "+NPv",
	"./Script_Extensions/Nushu.json": "+NPv",
	"./Script_Extensions/Ogham": "Cd+V",
	"./Script_Extensions/Ogham.json": "Cd+V",
	"./Script_Extensions/Ol_Chiki": "ir0e",
	"./Script_Extensions/Ol_Chiki.json": "ir0e",
	"./Script_Extensions/Old_Hungarian": "6e01",
	"./Script_Extensions/Old_Hungarian.json": "6e01",
	"./Script_Extensions/Old_Italic": "mNrg",
	"./Script_Extensions/Old_Italic.json": "mNrg",
	"./Script_Extensions/Old_North_Arabian": "rCWS",
	"./Script_Extensions/Old_North_Arabian.json": "rCWS",
	"./Script_Extensions/Old_Permic": "gNcX",
	"./Script_Extensions/Old_Permic.json": "gNcX",
	"./Script_Extensions/Old_Persian": "ZQKi",
	"./Script_Extensions/Old_Persian.json": "ZQKi",
	"./Script_Extensions/Old_South_Arabian": "XOkN",
	"./Script_Extensions/Old_South_Arabian.json": "XOkN",
	"./Script_Extensions/Old_Turkic": "J37f",
	"./Script_Extensions/Old_Turkic.json": "J37f",
	"./Script_Extensions/Oriya": "wxJe",
	"./Script_Extensions/Oriya.json": "wxJe",
	"./Script_Extensions/Osage": "5SoO",
	"./Script_Extensions/Osage.json": "5SoO",
	"./Script_Extensions/Osmanya": "VlhJ",
	"./Script_Extensions/Osmanya.json": "VlhJ",
	"./Script_Extensions/Pahawh_Hmong": "UiFE",
	"./Script_Extensions/Pahawh_Hmong.json": "UiFE",
	"./Script_Extensions/Palmyrene": "kIFa",
	"./Script_Extensions/Palmyrene.json": "kIFa",
	"./Script_Extensions/Pau_Cin_Hau": "1Zfo",
	"./Script_Extensions/Pau_Cin_Hau.json": "1Zfo",
	"./Script_Extensions/Phags_Pa": "2MkH",
	"./Script_Extensions/Phags_Pa.json": "2MkH",
	"./Script_Extensions/Phoenician": "8adC",
	"./Script_Extensions/Phoenician.json": "8adC",
	"./Script_Extensions/Psalter_Pahlavi": "8AkX",
	"./Script_Extensions/Psalter_Pahlavi.json": "8AkX",
	"./Script_Extensions/Rejang": "wV/l",
	"./Script_Extensions/Rejang.json": "wV/l",
	"./Script_Extensions/Runic": "mE6t",
	"./Script_Extensions/Runic.json": "mE6t",
	"./Script_Extensions/Samaritan": "FRzs",
	"./Script_Extensions/Samaritan.json": "FRzs",
	"./Script_Extensions/Saurashtra": "HFGM",
	"./Script_Extensions/Saurashtra.json": "HFGM",
	"./Script_Extensions/Sharada": "kgmR",
	"./Script_Extensions/Sharada.json": "kgmR",
	"./Script_Extensions/Shavian": "K7qM",
	"./Script_Extensions/Shavian.json": "K7qM",
	"./Script_Extensions/Siddham": "njO1",
	"./Script_Extensions/Siddham.json": "njO1",
	"./Script_Extensions/SignWriting": "iEYk",
	"./Script_Extensions/SignWriting.json": "iEYk",
	"./Script_Extensions/Sinhala": "cBan",
	"./Script_Extensions/Sinhala.json": "cBan",
	"./Script_Extensions/Sora_Sompeng": "rKP3",
	"./Script_Extensions/Sora_Sompeng.json": "rKP3",
	"./Script_Extensions/Soyombo": "lICw",
	"./Script_Extensions/Soyombo.json": "lICw",
	"./Script_Extensions/Sundanese": "LHmQ",
	"./Script_Extensions/Sundanese.json": "LHmQ",
	"./Script_Extensions/Syloti_Nagri": "HCgw",
	"./Script_Extensions/Syloti_Nagri.json": "HCgw",
	"./Script_Extensions/Syriac": "q4/5",
	"./Script_Extensions/Syriac.json": "q4/5",
	"./Script_Extensions/Tagalog": "gRKw",
	"./Script_Extensions/Tagalog.json": "gRKw",
	"./Script_Extensions/Tagbanwa": "L9JQ",
	"./Script_Extensions/Tagbanwa.json": "L9JQ",
	"./Script_Extensions/Tai_Le": "kyyj",
	"./Script_Extensions/Tai_Le.json": "kyyj",
	"./Script_Extensions/Tai_Tham": "NZA7",
	"./Script_Extensions/Tai_Tham.json": "NZA7",
	"./Script_Extensions/Tai_Viet": "mcnw",
	"./Script_Extensions/Tai_Viet.json": "mcnw",
	"./Script_Extensions/Takri": "cdsw",
	"./Script_Extensions/Takri.json": "cdsw",
	"./Script_Extensions/Tamil": "qR/L",
	"./Script_Extensions/Tamil.json": "qR/L",
	"./Script_Extensions/Tangut": "teu6",
	"./Script_Extensions/Tangut.json": "teu6",
	"./Script_Extensions/Telugu": "l224",
	"./Script_Extensions/Telugu.json": "l224",
	"./Script_Extensions/Thaana": "2zYI",
	"./Script_Extensions/Thaana.json": "2zYI",
	"./Script_Extensions/Thai": "HSbo",
	"./Script_Extensions/Thai.json": "HSbo",
	"./Script_Extensions/Tibetan": "+gJT",
	"./Script_Extensions/Tibetan.json": "+gJT",
	"./Script_Extensions/Tifinagh": "haI2",
	"./Script_Extensions/Tifinagh.json": "haI2",
	"./Script_Extensions/Tirhuta": "RNzY",
	"./Script_Extensions/Tirhuta.json": "RNzY",
	"./Script_Extensions/Ugaritic": "g+EV",
	"./Script_Extensions/Ugaritic.json": "g+EV",
	"./Script_Extensions/Vai": "Elbl",
	"./Script_Extensions/Vai.json": "Elbl",
	"./Script_Extensions/Warang_Citi": "kuCi",
	"./Script_Extensions/Warang_Citi.json": "kuCi",
	"./Script_Extensions/Yi": "ynwK",
	"./Script_Extensions/Yi.json": "ynwK",
	"./Script_Extensions/Zanabazar_Square": "4uRr",
	"./Script_Extensions/Zanabazar_Square.json": "4uRr",
	"./Word_Break/ALetter": "OQfW",
	"./Word_Break/ALetter.json": "OQfW",
	"./Word_Break/CR": "XsJR",
	"./Word_Break/CR.json": "XsJR",
	"./Word_Break/Double_Quote": "ES4Z",
	"./Word_Break/Double_Quote.json": "ES4Z",
	"./Word_Break/E_Base": "egaJ",
	"./Word_Break/E_Base.json": "egaJ",
	"./Word_Break/E_Base_GAZ": "AQqV",
	"./Word_Break/E_Base_GAZ.json": "AQqV",
	"./Word_Break/E_Modifier": "6rWH",
	"./Word_Break/E_Modifier.json": "6rWH",
	"./Word_Break/Extend": "7Qt0",
	"./Word_Break/Extend.json": "7Qt0",
	"./Word_Break/ExtendNumLet": "j6n0",
	"./Word_Break/ExtendNumLet.json": "j6n0",
	"./Word_Break/Format": "MG2e",
	"./Word_Break/Format.json": "MG2e",
	"./Word_Break/Glue_After_Zwj": "4908",
	"./Word_Break/Glue_After_Zwj.json": "4908",
	"./Word_Break/Hebrew_Letter": "Umu+",
	"./Word_Break/Hebrew_Letter.json": "Umu+",
	"./Word_Break/Katakana": "6MAv",
	"./Word_Break/Katakana.json": "6MAv",
	"./Word_Break/LF": "84ju",
	"./Word_Break/LF.json": "84ju",
	"./Word_Break/MidLetter": "Nfar",
	"./Word_Break/MidLetter.json": "Nfar",
	"./Word_Break/MidNum": "efi7",
	"./Word_Break/MidNum.json": "efi7",
	"./Word_Break/MidNumLet": "/OSY",
	"./Word_Break/MidNumLet.json": "/OSY",
	"./Word_Break/Newline": "g3le",
	"./Word_Break/Newline.json": "g3le",
	"./Word_Break/Numeric": "woz9",
	"./Word_Break/Numeric.json": "woz9",
	"./Word_Break/Other": "nH5d",
	"./Word_Break/Other.json": "nH5d",
	"./Word_Break/Regional_Indicator": "HBZ1",
	"./Word_Break/Regional_Indicator.json": "HBZ1",
	"./Word_Break/Single_Quote": "2sgj",
	"./Word_Break/Single_Quote.json": "2sgj",
	"./Word_Break/ZWJ": "Z60K",
	"./Word_Break/ZWJ.json": "Z60K"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SFwT";